import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { AddVacancyError } from '../../errors';
import { ESubdomain } from '../../constants/domain';
import {
  fetchAddVacancy,
  IAddVacancyResponse200,
  IAddVacancyResponse400,
} from '../../repositories/vacancies/v1/add-vacancy';
import { IVacancy } from '../..';

export interface IAddVacancyDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  subdomain: ESubdomain;
}

export interface IAddVacancyParams {
  vacancy: IVacancy;
  recaptcha: string;
}

export const addVacancy = async (deps: IAddVacancyDependencies, params: IAddVacancyParams) => {
  const { httpApi, logger, subdomain } = deps;
  const { vacancy, recaptcha } = params;

  try {
    const resp = await fetchAddVacancy<IAddVacancyResponse200, IAddVacancyResponse400>({
      httpApi,
      parameters: {
        captchaToken: recaptcha,
        vacancy: {
          description: vacancy.description,
          email: vacancy.contactEmail || null,
          employment: vacancy.employment,
          id: vacancy.id,
          maxSalary: vacancy.maxSalary || null,
          minExperience: vacancy.workExperience || null,
          minSalary: vacancy.minSalary || null,
          phone: vacancy.contactPhone || null,
          regionId: vacancy.region.id,
          specialization: vacancy.specialization,
        },
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/x-www-form-urlencoded']],
        },
      },
    });

    if (resp.statusCode !== 200) {
      throw new AddVacancyError({
        subdomain,
        message: resp.response.message,
        details: {
          error: JSON.stringify(resp.response.errors),
        },
      });
    }

    return resp.response.id;
  } catch (e) {
    logger.error(e);

    return;
  }
};
